import script from "./userDisputes.vue?vue&type=script&setup=true&lang=js"
export * from "./userDisputes.vue?vue&type=script&setup=true&lang=js"

import "./userDisputes.vue?vue&type=style&index=0&id=1e6e9aab&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e6e9aab"]])

export default __exports__